import { useState } from 'react'
import useSnackbar from 'hooks/useSnackbar'
import PropTypes from 'prop-types'

import { ConfirmationDialog, Permitted, LoadingFeedback } from 'components'

import helpers from 'helpers'
import constants from 'constants/index'
import * as service from 'service'

const InactivateProfileDialog = ({
  profile,
  open,
  setOpen,
  refresh,
  isCollaborator,
  isAdvisor = false,
}) => {
  const snackbar = useSnackbar()
  const [isLoading, setIsLoading] = useState(false)

  const changeStatusPermission = () => {
    if (isCollaborator)
      return constants.permissions.COLLABORATOR_PROFILES.CHANGE_STATUS
    if (isAdvisor) return constants.permissions.ADVISOR_PROFILE.CHANGE_STATUS

    return constants.permissions.CLIENT_PROFILES.CHANGE_STATUS
  }

  const changeStatusRoute = isCollaborator
    ? service.dponet.collaboratorProfiles.changeStatus
    : isAdvisor
    ? service.backoffice.advisorProfiles.changeStatus
    : service.backoffice.userProfiles.changeStatus

  const labelToChangeStatus = profile?.status ? 'inativar' : 'ativar '

  const onSubmit = async (profile) => {
    try {
      setIsLoading(true)
      await changeStatusRoute({ profileId: profile?.id })

      snackbar.open({
        message: `Perfil foi ${
          profile?.status ? 'ativado' : 'inativado'
        } com sucesso!`,
        variant: 'success',
      })
      refresh()
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Falha ao inativar o perfil!',
        variant: 'error',
      })
    } finally {
      setIsLoading(false)
      setOpen(false)
    }
  }

  return (
    <Permitted tag={changeStatusPermission}>
      <LoadingFeedback open={isLoading} />
      <ConfirmationDialog
        open={open}
        setOpen={setOpen}
        message={`Você tem certeza que deseja ${labelToChangeStatus} o perfil?`}
        buttonText="Confirmar"
        actionAcceptButton={() => onSubmit(profile)}
      />
    </Permitted>
  )
}

InactivateProfileDialog.propTypes = {
  profile: PropTypes.object,
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  refresh: PropTypes.func,
  isCollaborator: PropTypes.bool,
}
InactivateProfileDialog.defaultProps = {
  setOpen: () => {},
  refresh: () => {},
  isCollaborator: false,
}

export default InactivateProfileDialog
